<div class="dropdown-container">
  <button type="button"
          class="dropdown-button"
          (click)="toggle()"
          [class.active]="isOpen">
            <span class="mr-3">{{ buttonText }}</span>
            <i class="pi pi-angle-down" [class.rotated]="isOpen"></i>
  </button>

      <div class="dropdown-menu mt-3" [class.open]="isOpen">
        @for(item of items; track $index)
        {
          <a (click)="onItemClick(item)"
              [attr.href]="item.url || null"
              [attr.target]="item.url ? '_blank' : null"
              [attr.rel]="item.url ? 'noopener noreferrer' : null"
              class="menu-item"
              [class.disabled]="item.disabled">
              {{ item.label }}
          </a>
        }
      </div>
    </div>